/* eslint-disable prefer-destructuring */
import { createSlice } from '@reduxjs/toolkit';
import { doAddToCart, destroyLineItems } from 'shared/product_tabs/cart/thunks';
import initialState from 'shared/product_tabs/cart/data/initialState';

const cartSlice = createSlice({
  name: 'cartSlice',
  initialState,
  reducers: {
    toggleApplyCouponCode: (state, action) => {
      state.applyCouponCode = action.payload;
    },
    calculateEligibleCouponCode: (state, action) => {
      // We add the order total (every other line item in the cart) with
      // the total of this line item
      const productTotal = action.payload || 0;
      const total = state.orderTotal + productTotal;
      const options = [
        {
          productName: 'ViewMate Deluxe',
          couponCode: 'CHRISTMASVMD',
          range: [195, 695]
        },
        {
          productName: 'Viewmate Pro',
          couponCode: 'CHRISTMASVMP',
          range: [696, 1000000]
        },
      ];

      // Default to the first option if no eligible coupon
      let nextTarget = options[0].range[0];
      let currentTarget = 0;
      let remaining = 0;

      if (total) {
        const eligibleOption = options.find(option => total >= option.range[0] && total <= option.range[1]);

        if (eligibleOption) {
          state.couponCode = eligibleOption.couponCode;
          state.productName = eligibleOption.productName;

          // Set current target to the starting range of the eligible coupon
          currentTarget = eligibleOption.range[0];

          // Check if there is a next option to show remaining amount for the next available product
          const nextOption = options.find(option => total < option.range[0]);
          if (nextOption) {
            nextTarget = nextOption.range[0];
            remaining = nextTarget - total;
            state.nextOption = nextOption.productName;
          } else {
            remaining = 0;
            state.nextOption = undefined;
          }
        } else {
          state.couponCode = undefined;
          state.productName = undefined;
          state.applyCouponCode = false;

          // Find the next range for which the user can qualify
          const nextOption = options.find(option => total < option.range[0]);
          if (nextOption) {
            currentTarget = 0;
            nextTarget = nextOption.range[0];
            remaining = nextTarget - total;
            state.nextOption = nextOption.productName;
          } else {
            remaining = 0;
            state.nextOption = undefined;
          }
        }
      } else {
        const [nextOption] = options;

        state.productName = undefined;
        state.nextOption = nextOption.productName;
        state.couponCode = undefined;
        remaining = nextOption.range[0];
        nextTarget = nextOption.range[0];
        currentTarget = 0;
      }

      // Calculate the progress percentage toward the next promotion
      state.progress = ((total - currentTarget) / (nextTarget - currentTarget)) * 100;
      state.remaining = `$${remaining.toFixed(2)}`;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doAddToCart.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(doAddToCart.fulfilled, (state) => {
        state.addingToCart = true;
      })
      .addCase(doAddToCart.rejected, (state) => {
        state.addingToCart = false;
      })
      .addCase(destroyLineItems.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(destroyLineItems.fulfilled, (state) => {
        state.addingToCart = true;
      })
      .addCase(destroyLineItems.rejected, (state) => {
        state.addingToCart = false;
      });
  },
});

export const {
  toggleApplyCouponCode,
  calculateEligibleCouponCode,
} = cartSlice.actions;

export default cartSlice.reducer;
